<div class="container-fluid contenedor">
  <p class="title">404</p>
  <p class="sub-title">{{ "PageNotFound.texto" | translate }}</p>
  <a href="{{ urlApp }}">
    <button class="btn">{{ "GoToLogin.texto" | translate }}</button>
  </a>
</div>
